export type AdminGroup3 = {
  id: number;
  parentId: number | null;
  name: string;
  dispOrder: number | null;
};

export interface Group3InputModel {
  id: number | null; // null = 新規作成
  parentId: number | null;
  name: string;
  dispOrder: number | null;
}

export const createGroup3InitInputModel = (): Group3InputModel => ({
  id: null,
  parentId: null,
  name: '',
  dispOrder: null,
});
